import { Box } from "@mui/material";
import { Fragment } from "react";

import { chartPalette } from "../theme/tokens";

// The text of a page H1, shared by Welcome and BasePage. A pitch page title may
// break where the room puts a newline and colour one phrase in the design
// system's Blue via `data.titleHighlight` (exclusivity room, Elijah 2026-10-27:
// "Lilola Home could grow 18%" on the first line, "grow 18%" in blue).
export function PageTitle({ title, highlight }: { title: string; highlight?: string }) {
    return (
        <>
            {title.split("\n").map((line, i) => {
                const at = highlight ? line.indexOf(highlight) : -1;
                return (
                    <Fragment key={i}>
                        {i > 0 && <br />}
                        {at < 0 ? (
                            line
                        ) : (
                            <>
                                {line.slice(0, at)}
                                <Box component="span" sx={{ color: chartPalette[0] }}>
                                    {highlight}
                                </Box>
                                {line.slice(at + (highlight?.length ?? 0))}
                            </>
                        )}
                    </Fragment>
                );
            })}
        </>
    );
}
